// var templateUrl = site.theme_url; // this comes from functions.php

// Customize BootStrap - import only what we need
// import Alert from 'bootstrap/js/dist/alert';
// import Button from 'bootstrap/js/dist/button';
// import Carousel from 'bootstrap/js/dist/carousel';
// import Collapse from 'bootstrap/js/dist/collapse';
// import Dropdown from 'bootstrap/js/dist/dropdown';
// import Modal from 'bootstrap/js/dist/modal';
// import Offcanvas from 'bootstrap/js/dist/offcanvas';
// import Popover from 'bootstrap/js/dist/popover';
// import ScrollSpy from 'bootstrap/js/dist/scrollspy';
// import Tab from 'bootstrap/js/dist/tab';
// import Toast from 'bootstrap/js/dist/toast';
// import Tooltip from 'bootstrap/js/dist/tooltip';

// App
// import { MainMenu } from './modules/global/mainMenu';
// import { FrontPage } from './modules/pages/frontPage';

const initApp = () => {
  const bodyEl = document.getElementsByTagName('body')[0];

  // // GLOBAL
  // const mainMenu = new MainMenu();
  // mainMenu.init();

  // PAGE DETECTION
  if (bodyEl.classList.contains('home')) {
    // const frontPage = new FrontPage();
    // frontPage.init();
  }
};

(function () {
  document.documentElement.classList.remove('no-js');
  initApp();
})();
